// Where to go after signing in: a signed-out visit to an app page (e.g. a help article link) is
// remembered by PrivateRoute and used once by the sign-in page. Expires after an hour.
const KEY = 'postLoginPath';
const MAX_AGE_MS = 60 * 60 * 1000;

export const rememberReturnPath = path => {
  try { localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() })); } catch {}
};

export const takeReturnPath = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    localStorage.removeItem(KEY);
    if (saved && Date.now() - saved.at < MAX_AGE_MS && /^\/(?!signin|signup)/.test(saved.path)) return saved.path;
  } catch {}
  return '/workspace';
};
